import React from 'react';
import { Star, Quote } from 'lucide-react';

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Michael S.",
      location: "Hamburg-Altona",
      rating: 5,
      text: "Termin wurde innerhalb 30 Minuten vereinbart. Gutachter war super professionell und hat alles genau dokumentiert. Versicherung hat ohne Probleme gezahlt.",
      date: "Vor 2 Wochen",
      vehicle: "VW Golf"
    },
    {
      name: "Sandra K.",
      location: "Norderstedt",
      rating: 5,
      text: "Sehr faire Schadensbewertung. Wertminderung wurde korrekt berechnet und ich habe 1.200€ mehr bekommen als erwartet. Absolut empfehlenswert!",
      date: "Vor 1 Monat",
      vehicle: "Audi A4"
    },
    {
      name: "Thomas B.",
      location: "Pinneberg",
      rating: 5,
      text: "Schnelle Terminvergabe, kompetente Beratung. Das Gutachten war nach 2 Tagen fertig. Genau wie versprochen. Top Service!",
      date: "Vor 3 Wochen",
      vehicle: "BMW 320d"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Das sagen unsere Kunden
          </h2>
          <p className="text-lg text-gray-600">Echte Bewertungen von echten Kunden</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, idx) => (
            <div key={idx} className="bg-gray-50 rounded-2xl p-6 border-2 border-gray-200 hover:border-brand-green transition-all">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-brand-green fill-brand-green" />
                ))}
              </div>
              
              <Quote className="w-8 h-8 text-brand-green/20 mb-3" />
              
              <p className="text-gray-700 leading-relaxed mb-4 italic">
                "{testimonial.text}"
              </p>
              
              <div className="border-t border-gray-300 pt-4">
                <p className="font-semibold text-gray-900">{testimonial.name}</p>
                <p className="text-sm text-gray-600">{testimonial.location} • {testimonial.vehicle}</p>
                <p className="text-xs text-gray-500 mt-1">{testimonial.date}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <a href="/bewertungen" className="text-brand-green hover:text-brand-green-dark font-semibold underline">
            Alle 150+ Bewertungen lesen →
          </a>
        </div>
      </div>
    </section>
  );
};